import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const ViewPurchased = () => {

    const [selectedClient, setSelectedClient] = useState('');
    const [clients, setClients] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');

    const [userPacking, setUserPacking] = useState(null);
    const [userNetWeight, setUserNetWeight] = useState(null);
    const [userQuantity, setUserQuantity] = useState(null);

    const [totalWeight, setTotalWeight] = useState(null);
    const [userShortage, setUserShortage] = useState(0);

    const [dataPrice, setDataPrice] = useState(null);
    const [dataTotalPrice, setDataTotalPrice] = useState(null);

    const navigate = useNavigate();

    const [inputs, setInputs] = useState([]);

    const { id } = useParams();

    useEffect(() => {
        getUser();

        fetch('https://react-apis.dotlocalhost.com/purchase.php')
            .then(response => response.json())
            .then(data => setUsers(data))
            .catch(error => console.error('Error fetching users:', error));

        fetch('https://react-apis.dotlocalhost.com/dropclient.php')
            .then(response => response.json())
            .then(data => setClients(data))
            .catch(error => console.error('Error fetching client names:', error));

    }, []);

    // Fetch the last name of the selected user
    const handleUserChange = (event) => {
        const ProName = event.target.value;
        setSelectedUser(ProName);
        if (ProName) {
            fetch(`https://react-apis.dotlocalhost.com/purchase.php?productName=${ProName}`)
                .then(response => response.json())
                .then(data => setUserPacking(data.packing) | setUserNetWeight(data.netWeight) | setUserQuantity(userQuantity) | setTotalWeight(totalWeight) | setUserShortage(userShortage))
                //.then(data => setUserNetWeight(data.netWeight))
                .catch(error => console.error('Error fetching packing:', error));
        } else {
            setUserPacking(null);
            setUserNetWeight(null);
            setUserQuantity(null);
            setTotalWeight(null);
            setUserShortage(null);

        }
    };


    const handleClientChange = (event) => {
        setSelectedClient(event.target.value);
    };

    useEffect(() => {
        const calculateTotalWeight = () => {
            const total = (userNetWeight * userQuantity) - userShortage;
            setTotalWeight(total);
            const total2 = totalWeight * dataPrice;
            setDataTotalPrice(total2);
        };
        calculateTotalWeight();
    }, [userNetWeight, userQuantity, userShortage, totalWeight, dataPrice]);

    function getUser() {
        axios.get(`https://react-apis.dotlocalhost.com/purchaseShow.php/${id}`).then(function (response) {
            console.log(response.data);
            setInputs(response.data);
        });
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({ ...values, [name]: value }));
    }

    // date defferent

    //const [duedate, setDuedate] = useState([]);

    const calculateDaysLeft = (duedate) => {
        const currentDate = new Date();
        const inputs = new Date(duedate);
        const timeDiff = inputs - currentDate;
        const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        return daysLeft >= 0 ? daysLeft : 0; // Ensure no negative days
    };

    // date defferent

    return (
        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>View Purchased Items</h3>
                        </div>
                    </div>

                    {calculateDaysLeft(inputs.duedate) < 3 && (
                        <p style={{ color: 'white', backgroundColor: 'red', width: '450px', padding: '10px', textAlign: 'center', fontSize: '20px', fontWeight: '600', borderRadius: '25px' }}>The due date is less than 2 days away!</p>
                    )}

                    <div className='row'>
                        <div className='col-3'>
                            <label for="" class="form-label">Client Name</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.clientName} />
                        </div>
                        <div className='col-3'>
                            <label for="" class="form-label">Shipping Mark</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.shipping_mark} />
                        </div>
                        <div className='col-3'>
                            <label for="" class="form-label">Purchage Id</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.purchage_Id} />
                        </div>
                        <div className='col-3'>
                            <label for="" class="form-label">Product Name</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.productName} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-2'>
                            <label for="" class="form-label">Packing</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.packing} />
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Net Weight</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.netWeight} />
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Quantity</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.quantity} />
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Shortage</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.shortage} />
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Total Weight</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.totalWeight} />
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Price</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.price} />
                        </div>
                    </div>
                    <div className='row'>                                                
                        <div className='col-2'>
                            <label for="" class="form-label">Total Bill</label>
                            <input type="text" readOnly="true" className='form-control' onChange={handleChange} value={inputs.totalBill} />
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Due Date</label>
                            <input type="date" readOnly="true" className='form-control' onChange={handleChange} value={inputs.duedate} dateFormat="dd-MMM-yyyy"/>
                        </div>
                        <div className='col-2'>
                            <label for="" class="form-label">Remaining Date</label>
                            <input type="text" readOnly="true" className='form-control' value={calculateDaysLeft(inputs.duedate)} />
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )

}

export default ViewPurchased;